import { Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { MusicsDataService } from '../../providers/Table/musicsData.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-artist-instagram-search',
  templateUrl: './artistInstagramSearch.component.html',
  styleUrls: ['./artistInstagramSearch.component.scss']
})
export class ArtistInstagramSearch implements OnInit, AfterViewInit {

  musicbrainzResults: any[] = [];

  geniusResults: any[] = [];

  loading = false;

  dataOut = {
    startRow: 0,
    endRow: 0,
    instagram: '',
    edit: false
  };

  @ViewChild('searchInput') searchInput;

  constructor(private musicsDataService: MusicsDataService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              @Inject(MAT_DIALOG_DATA) private dataIn,
              private dialogRef: MatDialogRef<any>) {
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/close.svg'));
  }

  ngOnInit() {
    this.dataOut.startRow = this.dataIn.startRow;
    this.dataOut.endRow = this.dataIn.endRow;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchInput.nativeElement.value = this.dataIn.search;
      this.searchArtistInstagram(this.dataIn.search);
    });
  }

  searchArtistInstagram(search) {
    this.musicbrainzResults = [];
    this.geniusResults = [];
    if (search && search.length > 0) {
      this.loading = true;
      this.musicsDataService.searchArtistInstagram(search)
        .then(res => {
          this.loading = false;
          this.musicbrainzResults = res.musicbrainz || [];
          this.geniusResults = res.genius || [];
        })
        .catch(() => {
          this.loading = false;
          this.musicbrainzResults = [];
          this.geniusResults = [];
        });
    }
  }

  searchArtistInstagramEnter(e, search) {
    e.preventDefault();
    this.searchArtistInstagram(search);
  }

  selectInstagram(instagram) {
    this.dataOut.edit = true;
    this.dataOut.instagram = instagram;
    this.dialogRef.close(this.dataOut);
  }

  /* Ouvre le profil pour vérification avant de choisir ce candidat, sans fermer la modale. */
  instagramProfileUrl(instagram: string): string {
    const handle = (instagram || '').replace(/^@/, '');
    return 'https://www.instagram.com/' + encodeURIComponent(handle) + '/';
  }

}
